import React, { useEffect, useState } from 'react';
import './Trailer.scss';
import VideoPlayer from '../../../../components/VideoPlayer/VideoPlayer';
import { safeHtml } from '../../../../services/helpers';
import { baseStrapiURL } from '../../../../services/config';

function getCoverUrl(cover) {
    const formats = cover?.formats;
    const url = (formats?.large ?? formats?.medium ?? formats?.small ?? formats?.thumbnail)?.url ?? cover?.url;
    return url ? baseStrapiURL + url : null;
}

export default function Trailer({ content }) {
    const [hasStarted, setHasStarted] = useState(false);
    const coverUrl = getCoverUrl(content.CoverVidéo);
    const [poster, setPoster] = useState(coverUrl);

    useEffect(() => {
        if (!coverUrl) return;
        const img = new Image();
        img.src = coverUrl;
        img.onload = () => setPoster(coverUrl);
    }, [coverUrl]);

    return (
        <div className='workshop-trailer'>
                <VideoPlayer
                    src={baseStrapiURL + content.Vidéo.url}
                    poster={poster}
                    autoPlay={false}
                    controls={true}
                    loop={false}
                    muted={false}
                    hasStarted={hasStarted}
                    setHasStarted={setHasStarted}
                />
                {
                    !hasStarted && 
                        <div className="workshop-trailer__text" dangerouslySetInnerHTML={safeHtml(content.Texte)} />
                }
        </div>
    );
}